<div class="header">
  <div class="header-title">
    <div class="header-title-row">
      <h1 [matTooltip]="title || ' '">
        {{ title || '' }}
      </h1>
      <ng-content select="[header-title-action]"></ng-content>
    </div>
    <h3 *ngIf="subtitle">{{ subtitle }}</h3>
  </div>
  <ng-content select="[header-button]"></ng-content>
</div>
<div class="line"></div>
